import React from 'react';
import {
  withStyles,
} from '@material-ui/core';
import { withI18n } from 'react-i18next';
import { Link } from 'react-router-dom';
import { watchHgAcademyClick, getHgAcademyClick } from '@/utils/ThirdParties/tagManager';
import { config } from '@/config';
import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { getTokens } from '@/redux/actions/academyPass';
import { useHistory } from 'react-router';
import * as Styles from './CourseCard.styles';
import {
  Button, IconCourses, IconRatingStar, IconSpeed, Tag,
} from 'gatorcomponents';

const CourseCard = ({
  classes, t, course, userId, isPassActive, isPaidAndActive, cardType,
}) => {
  const { PASS_BASE_URL } = config;
  const courseTitle = course.name.length > 55 ? course.name.substr(0, 55).concat('...') : course.name;
  const { jwt } = useSelector(state => state.academyPass.tokens);
  const dispatch = useDispatch();
  const history = useHistory();

  const courseImage = () => (
    <Styles.ImageWrapper>
      <Styles.Image className={classes.cardImage} src={course.thumbnail} alt={course.name} data-testid="course-info-image" />
      <Styles.TagWrapper>
        {course.isFree && (
        <Tag
          label={t('academypass.card.free')}
          variant="active"
        />
        )}
        {!course.isFree && (
        <Tag
          label={t('academypass.card.pass')}
          variant="pending"
        />
        )}
      </Styles.TagWrapper>
    </Styles.ImageWrapper>
  );

  const courseInfo = () => (
    <div className={classes.infoWrapper}>
      <div className={classes.info} data-testid="course-info-content-count">
        <IconCourses />
        {`${course.contentCount ? course.contentCount : 0} ${t('academypass.card.classes')}`}
      </div>
      <div className={classes.info} data-testid="course-info-workload">
        <IconSpeed secondaryColor="transparent" />
        {`${course.workload ? course.workload : 0} ${t('academypass.card.minutes')}`}
      </div>
    </div>
  );

  const ratingInfo = (value) => {
    const stars = [];

    for (let i = 0; i < value; i += 1) {
      stars.push(
        <IconRatingStar
          testId="rating-star"
          key={`ratingstar${i}`}
          color="attentionPure"
          filled
        />,
      );
    }

    for (let j = 0; j < (5 - value); j += 1) {
      stars.push(
        <IconRatingStar
          testId="rating-empty-star"
          key={`retingemptystar${j}`}
          color="attentionPure"
        />,
      );
    }
    return stars;
  };

  const accessCourseLaunchLab = () => {
    dispatch(getTokens());
    watchHgAcademyClick(course.name);

    window.open(`${PASS_BASE_URL}/public/login?token=${jwt}&redirect_url=${PASS_BASE_URL}/users/${userId}/products/${course.idProduct}`, '_blank').focus();
  };

  const handleClick = () => {
    const showLP = false;
    getHgAcademyClick(course.name);
    showLP ? history.push(t('routes.coursesTrial')) : history.push(t('routes.coursesCta'));
  };

  const isAvailable = (isPaidAndActive && isPassActive) || course.isFree;

  return (
    <Styles.CourseCard data-testid={cardType} key={course.idProduct}>
      {courseImage()}
      <Styles.CourseTitle>
        {courseTitle}
      </Styles.CourseTitle>
      <Styles.DetailsWrapper>
        {courseInfo()}
        <Styles.RatingStars>
          {ratingInfo(parseInt(course.ratingAverage, 10))}
        </Styles.RatingStars>
        {isAvailable && (
          <Button
            onClick={accessCourseLaunchLab}
            className={classes.watchButton}
            component={Link}
            to="#"
            rel="noopener noreferrer"
            data-testid="btn-card-watch"
            label={t('academypass.card.watch')}
            variant="secondary"
          />
        )}

        {!isAvailable && (
          <Button
            onClick={handleClick}
            className={classes.buyButton}
            data-testid="btn-card-buy"
            label={t('academypass.card.buy')}
          />
        )}
      </Styles.DetailsWrapper>
    </Styles.CourseCard>
  );
};

export default withI18n()(withStyles(styles, { withTheme: true })(CourseCard));
